<template>
    <div class="orgDetail">
        <div class="left-box">
            <LeftPage :active="6"/>
        </div>
        <div class="right-box flex flex-direction">
            <div class="table-box flex-sub">
                <div class="title">
                    <div class="icon-box">
                        <i class="iconfont icon-yujing"></i>
                    </div>
                    <b>机构公示信息管理</b>
                </div>
                <div class="search-flex">
                    <div class="search-box">
                        <div class="search-btn" @click="refreshList">
                            <i class="iconfont icon-sousuo"></i>应用系统内容公示
                        </div>
                        <a class=" shensu margin-lr-sm" target="_blank">
                            <i class="iconfont icon-xiazai"></i>模版下载
                        </a>
                        <upload-file>
                            <div slot="upload" class="search-btn">
                                <i class="iconfont icon-shangchuan"></i>上传公示内容
                            </div>
                        </upload-file>
                        <div class="shensu margin-left-sm" @click="addItem(false)" v-if="tableData.length">
                            <i class="iconfont icon-xiazai"></i>下载系统公示内容
                        </div>
                    </div>
                    <div class="shensu margin-left-sm" @click="addItem(false)" v-if="tableData.length">
                        <i class="iconfont icon-fasong"></i>确认发布
                    </div>
                </div>

                <div class="search-flex">
                    <div class="search-box"  v-if="tableData.length">
                        <el-form ref="form" :model="search" class="flex" label-width="80px">
                            <el-form-item label="关键词">
                                <el-input v-model="search.org_name" placeholder="请输入关键词"></el-input>
                            </el-form-item>
                            <el-form-item label="星级">
                                <el-select v-model="search.is_lock" placeholder="请选择">
                                    <el-option
                                        v-for="item in evaluateOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="预警">
                                <el-select v-model="search.level" :clearable="true" class="inp" placeholder="请选择">
                                    <el-option
                                        v-for="item in riskLevelAllOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                        <div class="search-btn margin-left-sm" @click="refreshList">
                            <i class="iconfont icon-sousuo"></i>搜索
                        </div>
                    </div>
                </div>
                <div class="list ">
                    <el-table
                        :cell-style="textCenter"
                        :data="tableData"
                        :header-cell-style="centerbgc"
                        border
                        style="width: 100%" v-if="tableData.length">
                        <el-table-column
                            label="序号"
                            type="index"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            label="机构名称"
                            prop="org_name"
                            width="">
                        </el-table-column>
                        <el-table-column
                            label="预警"
                            width="200">
                            <template slot-scope="scope">
                                <span class="level" :class="getLevelClass(scope.row.level)">{{ scope.row.level | level }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="星级"
                            width="200">
                            <template slot-scope="scope">
                                <span class="status">{{ scope.row.status | star }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="预警原因"
                            prop="org_name"
                            width="">
                        </el-table-column>
                    </el-table>
                    <el-empty v-else description="请先生成或添加机构"></el-empty>
                </div>

                <div class="page-box">
                    <el-pagination
                        v-if="tableData.length"
                        :current-page.sync="search.page"
                        :page-size="search.limit"
                        :total="search.total"
                        background
                        class="page-all margin-top self-end"
                        layout="prev, pager, next"
                        @current-change="list">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {evaluateOptions, riskLevelAllOptions} from "@/utils/const";
import {findByType} from "@/utils/utils";
import {org_lst} from "@/api/admin";
import LeftPage from "@/views/admin/pages/info/common/leftPage";
import UploadFile from "@/components/UploadFile";

export default {
    name: "objectionAppeal",
    data() {
        return {
            riskLevelAllOptions: riskLevelAllOptions,
            evaluateOptions: evaluateOptions,
            search: {
                org_name: '',
                page: 1,
                limit: 10,
                total: 0,
            },
            tableData: [],

            cur_item:'',
        }
    },
    components: {UploadFile, LeftPage},
    computed: {
        textCenter() {
            return {
                textAlign: 'center'
            }
        },
        centerbgc() {
            return {
                textAlign: 'center',
                background: '#f7f7f7'
            }
        }
    },
    created() {
        this.$emit("setActive", {
            headActive: 5
        })
    },
    methods: {
        async list() {
            let _data = await org_lst(
                this.search.org_name,
                this.search.license,
                this.search.is_lock,
                this.search.peixun_lei,
                this.search.page,
                this.search.limit
            );
            if (_data.status == 200) {
                this.tableData = _data.data.data
                this.search.total = _data.data.total
            } else {
                this.$message.error(_data.msg)
            }
        },
        refreshList() {
            this.search.page = 1
            this.list()
        },
        getLevelClass(val) {
            return findByType(riskLevelAllOptions, val, {key: 'value', value: 'type'})
        },
    },
    watch: {},
    filters: {
        level(val) {
            let label = findByType(riskLevelAllOptions, val);
            return label.substring(label.length - 2)
        },
        star(val) {
            return findByType(evaluateOptions, val)
        },
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #f61919;
}
.orgDetail {
    width: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;
    display: flex;
    justify-content: flex-start;

    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid #e3e7f0;
        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 10px;
        }
        .icon-box {
            width: 30px;
            height: 30px;
            background-image: linear-gradient(-30deg,
                #3579fb 0%,
                #44a3ff 100%);
            box-shadow: 0px 10px 10px 0px
            rgba(50, 150, 255, 0.3);
            border-radius: 10px;
            text-align: center;
            line-height: 30px;

            i {
                font-size: 20px;
                color: #ffffff;
            }
        }
    }
}
.right-box {
    flex: 1;
    margin-left: 25px;
    width: 100%;
      min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;

    .table-box {
        width: 100%;
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 30px 20px 0;
        border-radius: 10px;
        min-height: 500px;

        .tab {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: solid 2px #e3e7f0;

            span {
                width: max-content;
                margin-left: 45px;
                height: 60px;
                line-height: 60px;
                font-size: 18px;
                color: #63686e;
                margin-right: 20px;
                cursor: pointer;

                &.active {
                    color: #2791ff;
                    font-weight: bold;
                    border-radius: 2px;
                    border-bottom: solid 4px #2791ff;
                }
            }
        }


        .list {
            width: 100%;
            .level{
                background-color: #f2f2f2;
                border-radius: 4px;
                font-size: 14px;
                line-height: 26px;
                text-align: center;
                color: #8a8a8a;
                width: 60px;
                height: 26px;
                display: inline-block;
                &.text{
                    width: unset!important;
                    height: unset!important;
                    background: none!important;
                }
                &.green{
                    background-color: #d9f7be;
                    color: #0e7701;
                }
                &.red{
                    background-color: #ffdddd;
                    color: #f8001a;
                }
                &.yellow{
                    background-color: #fffbdd;
                    color: #fad471;
                }
                &.orange{
                    background-color: #ffeddd;
                    color: #f58739;
                }
            }
        }

        .search-flex {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 20px 0;

            .shensu {
                min-width: 113px;
                height: 37px;
                background-image: linear-gradient(0deg,
                    #f59a23 0%,
                    #feb555 100%);
                border-radius: 4px;
                padding: 0 20px;
                text-align: center;
                line-height: 37px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;

                i {
                    font-size: 20px;
                    margin-right: 5px;
                    color: #ffffff;
                }
            }

            .search-box {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .search-btn {
                    min-width: 112px;
                    height: 36px;
                    background-image: linear-gradient(0deg,
                        #2791ff 0%,
                        #81b6ff 100%);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-size: 16px;
                    color: #ffffff;
                    cursor: pointer;
                    padding: 0 20px;

                    i {
                        font-size: 20px;
                        margin-right: 5px;
                        color: #ffffff;
                    }

                    &.reset {
                        background-image: none;
                        background-color: #ffffff;
                        border-radius: 4px;
                        border: solid 1px #cccccc;
                        line-height: 34px;
                        color: #333333;

                        i {
                            color: #999999;
                        }
                    }
                }
            }

        }
    }
}
</style>


